export default __webpack_public_path__ + "static/media/speaker-gif.b1954d5e.gif";